/**
 * Created By xiyuan
 * Author server@xiyuan.name (惜缘叛逆)
 * DateTime 2019/3/26 13:11
 * Describe javascript功能
 * MIT License http://www.opensource.org/licenses/mit-license.php
 */
import md5 from 'md5';

export default function devicetype() {
	console.log('获取设备')
	const userAgent = navigator.userAgent;
	// 是否微信环境
	const isWechat = userAgent.match(/MicroMessenger|wechat/i);
	// 是否支付宝环境
	const isAlipay = userAgent.match(/AlipayClient/i);
	// 检查是否移动端
	const isMobile = /Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent);
	// 检查是否App内
	const isApp = window.isApp || window.cordova;
	// 检查是否android系统环境
	const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
	// 检查是否ios系统环境
	const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  // 抖音
  if (/toutiaomicroapp/i.test(userAgent)) {
    // 头条小程序 JS-SDK 如果不需要兼容头条小程序，则无需引用此 JS 文件。
  }

  if (isApp) {
		switch (true) {
			case isAndroid:
				return {
					code: 3,
					name: 'ANDROID',
				};
			case isIOS:
				return {
					code: 4,
					name: 'IOS',
				};
		}
	}
	
	// 是否微信环境
	if (isWechat) return {
		code: 5,
		name: 'WECHAT',
	};
	
	// 是否移动端
	if (isMobile) {
		return {
			code: 1,
			name: 'WAP',
		};
	} else {
		return {
			code: 2,
			name: 'WEB',
		};
	}
	
}


// 获取设备id
export function getDeviceId() {
    const clientIdName = '__client__Id__reinforce__';
    // 检查本地是否存在客户端id，如果没有则生成
    const clientId = localStorage.getItem(clientIdName) || md5(Date.now() + '&:' + (((1 + Math.random()) * 0x10000) | 0));
    const uuid =/* (window.device && window.device.uuid) ? window.device.uuid :*/ clientId;
    localStorage.setItem(clientIdName, uuid);
    return clientId;
}